import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { If } from 'utils';
import { UiKit } from 'components';
import { useAppContext } from 'utils/hooks';
import { refreshSite } from 'utils/methods';
import notFoundImage from 'assets/rr-illustrations/lost.png';
import { ReactComponent as SettingsIcon } from 'assets/ss-icons/zero-state-icons/setting.svg';

export default function ErrorView({
  homeButton = false,
  allowRefresh = false,
  title = 'Error - Something went wrong',
  message = 'Something went wrong. Please retry or check your connection.\n If the error persists, please contact support',
  className = '',
  imageContainerClassName = '',
  imageClassName = '',
  textClassName = '',
  buttonClassName = ''
}) {
  const { isSSRMode } = useAppContext();

  return (
    <div className={cn('ErrorPage', className)}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={cn('ErrorPage__image', imageContainerClassName)}>
        <If test={!isSSRMode} otherwise={<SettingsIcon className="mt-5" />}>
          <img src={notFoundImage} alt="not found" className={imageClassName} />
        </If>
      </div>
      <div className={cn('ErrorPage__text', textClassName)}>{message}</div>
      <If test={homeButton || allowRefresh}>
        <UiKit.Grid gap="8" className="mt-4" templateColumns="auto 1fr">
          <If test={homeButton}>
            <Link to="/">
              <UiKit.Button
                variant="outline"
                className={cn('ErrorPage__button', buttonClassName)}
              >
                Back To Home
              </UiKit.Button>
            </Link>
          </If>
          <If test={allowRefresh}>
            <UiKit.Button
              onClick={refreshSite}
              className={cn('ErrorPage__button', buttonClassName)}
            >
              Refresh this page
            </UiKit.Button>
          </If>
        </UiKit.Grid>
      </If>
    </div>
  );
}
